import { makeStub } from "./_base";
export const Warehouse = makeStub("Warehouse");
